import { useMergedThreadMetadata } from '#pplx/frontend/apps/ask/hooks/threads-hooks/useMergedThreadMetadata.js';
import { useResults } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { COMPUTER_PAGE_TITLE } from '#pplx/frontend/apps/ask/spa/metadata/metadata.js';
export function useComputerThreadDocumentTitle(slug) {
    const { firstResult } = useResults();
    const matchesRoute = !!slug &&
        [
            firstResult?.context_uuid,
            firstResult?.backend_uuid,
            firstResult?.frontend_uuid,
            firstResult?.thread_url_slug,
        ].includes(slug);
    const metadata = useMergedThreadMetadata(matchesRoute ? firstResult?.context_uuid : undefined);
    // Context renames arrive independently of the first entry's streaming payload.
    // Never fall back to query_str or a result left over from the previous route.
    return (matchesRoute && (metadata?.title || firstResult?.thread_title)) || COMPUTER_PAGE_TITLE;
}
//# sourceMappingURL=useComputerThreadDocumentTitle.js.map